import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import SocialList from './SocialList';
import iconsList from './iconsListData.js';
import asaLogoUrl from '../../images/header/asa-logo.svg';

// const Footer = () => (
// 	<footer className='bg-slate-800 py-3  border-0 border-t border-solid border-gray-200'>
// 		<div className='container mx-auto  flex flex-col space-y-3 md:flex-row  justify-between items-center text-center md:text-left'>
// 			<Button
// 				className='bg-slate-100'
// 				component={Link}
// 				to='/home'
// 				variant='outlined'
// 			>
// 				<img
// 					src={asaLogoUrl}
// 					alt='Amr Saad Abdallah Logo'
// 					className='w-10 sm:w-12 p-1 '
// 				/>
// 			</Button>

// 			<p className='uppercase text-base lg:text-lg text-gray-100 tracking-widest order-2 md:order-none'>
// 				2022 &copy; Amr Saad Abdallah
// 			</p>

// 			<Box>
// 				<SocialList
// 					className='justify-center md:justify-start '
// 					iconsList={iconsList}
// 				/>
// 			</Box>
// 		</div>
// 	</footer>
// );

const Footer = () => (
	<footer className='py-3  border-0 border-t border-solid border-gray-200'>
		<div className='container mx-auto  flex flex-col space-y-3 md:flex-row  justify-between items-center text-center md:text-left'>
			<Button component={Link} to='/home' variant='outlined'>
				<img
					src={asaLogoUrl}
					alt='Amr Saad Abdallah Logo'
					className='w-12 p-1'
				/>
			</Button>

			<p className='uppercase lg:text-xl text-gray-600 tracking-widest order-2 md:order-none'>
				2022 &copy; Amr Saad Abdallah
			</p>

			<Box>
				<SocialList
					className='justify-center md:justify-start '
					iconsList={iconsList}
				/>
			</Box>
		</div>
	</footer>
);

export default Footer;
